import styled from 'styled-components';
import IconButton from '../../icon-button';
export var InputBoxWithArrowButton = /*#__PURE__*/styled.div.withConfig({
  displayName: "style__InputBoxWithArrowButton",
  componentId: "sc-1rhpuwc-0"
})(["position:relative;"]);
export var ArrowButton = /*#__PURE__*/styled(IconButton).withConfig({
  displayName: "style__ArrowButton",
  componentId: "sc-1rhpuwc-1"
})(["visibility:visible;opacity:1;transition:100ms linear all;position:absolute;right:0;top:9px;margin:4px;", ""], p => p.hide && "\n        visibility: hidden;\n        opacity: 0;\n        transition: 0ms linear all;\n    ");